/*
 * Digits 0-9 with a trailing 0 so a reel can roll from 9 back to 0 by sliding
 * one more step instead of jumping — the duplicate makes the wrap seamless.
 */
export const SLOT_REEL = '01234567890';
export const SLOT_DIGITS = SLOT_REEL.split('');

/*
 * The vertical height of a digit slot should be equal to the line height of the reel,
 * so that each digit will fill the slot exactly. Therefore, we set the height to 1.4em,
 * and the line height to 1.4, which resolve to the same pixel value.
 */
export const REEL_DIGIT_HEIGHT = 1.4;

/**
 * A reel carries the digits 0-9, so it wraps every ten steps — which is also
 * what gives the counter its base-10 place values (units, tens, hundreds...).
 */
export const DIGITS_PER_REVOLUTION = 10;
export const MS_PER_SECOND = 1000;

/**
 * Reels that complete a full revolution within this window spin continuously
 * (positioned every frame from the live value); anything slower would visibly
 * float between digits, so it cascades instead.
 */
export const CONTINUOUS_SPIN_MAX_S = 4;
/**
 * Ceiling on a continuous reel's visible spin, in revolutions per second. Reels
 * slower than this stay locked to the live value so their digits and carries
 * line up; faster ones are an unreadable blur, so we cap them here to stop the
 * spin from strobing.
 */
export const MAX_REEL_REVS_PER_S = 4;
/**
 * A cascading reel rolls for this fraction of the gap between its own carries,
 * then rests on a whole number until the next carry.
 */
export const CASCADE_ROLL_FRACTION = 0.4;
export const CASCADE_MIN_ROLL_MS = 120;
export const CASCADE_MAX_ROLL_MS = 700;
export const CASCADE_TICK_MS = 60;
export const CASCADE_EASING = 'cubic-bezier(0.3, 0, 0.2, 1)';
/**
 * The largest frame delta we let advance the counter. requestAnimationFrame
 * pauses while the tab is backgrounded, so the first frame back can report a
 * gap of many seconds; clamping it keeps the reels from spinning to catch up.
 */
export const MAX_FRAME_GAP_MS = 250;

/**
 * WARNING: keep INCREMENT_JITTER_FACTOR <= 1. Above 1 the rolled target can go
 * negative, which makes the counter visibly tick backwards — obvious the moment
 * you watch it locally, but easy to reintroduce while tuning these numbers.
 */
export const INCREMENT_JITTER_FACTOR = 0.5;
export const INCREMENT_REROLL_MS = 1500;
export const INCREMENT_SMOOTH_TAU_MS = 700;
